<template>
	<div class="pickUp-method-form">
		<div class="form-row">
			<div v-if="isAvailableTableSwitch" class="input-wrapper">
				<div
					v-if="isAvailableTableSwitch && isTableNumberValid"
					class="error-hint"
				>
					桌號不能為空
				</div>
				<Input
					title="桌號"
					v-model="tableNumber"
					:class="{ 'error-input': isTableNumberValid }"
				/>
			</div>
			<div v-if="isAvailableNameSwitch" class="input-wrapper">
				<div v-if="isAvailableNameSwitch && isUserNameValid" class="error-hint">
					姓名不能為空
				</div>
				<Input
					title="姓名"
					v-model="userName"
					:class="{ 'error-input': isUserNameValid }"
				/>
			</div>
			<div v-if="isAvailablePhoneSwitch" class="input-wrapper">
				<div v-if="isAvailablePhoneSwitch && isPhoneValid" class="error-hint">
					電話不能為空
				</div>
				<div
					v-if="isAvailablePhoneSwitch && isPhoneFormatValid"
					class="error-hint"
				>
					電話格式不正確
				</div>
				<Input
					title="電話"
					v-model="phone"
					:class="{ 'error-input': isPhoneValid || isPhoneFormatValid }"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Input from '@/components/Input.vue'

export default {
	name: 'DineInForm',
	components: { Input },
	props: {
		formData: {
			type: Object,
			default: () => ({
				tableNumber: null,
				userName: null,
				phone: null,
			}),
		},
		errorValidate: {
			type: Object,
		},
		pickUpDraft: {
			type: Object,
		},
	},
	data() {
		return {
			tableNumber: null,
			userName: null,
			phone: null,
		}
	},
	computed: {
		isTableNumberValid() {
			return this.errorValidate.tableNumber
		},
		isUserNameValid() {
			return this.errorValidate.userName
		},
		isPhoneValid() {
			return this.errorValidate.phone
		},
		isPhoneFormatValid() {
			return this.errorValidate.phoneFormat
		},
		isAvailableTableSwitch() {
			return this.$store.state.store?.openInfo?.mobilePickupMethod?.dineIn
				?.tableNumberSwitch
		},
		isAvailableNameSwitch() {
			return this.$store.state.store?.openInfo?.mobilePickupMethod?.dineIn
				?.nameSwitch
		},
		isAvailablePhoneSwitch() {
			return this.$store.state.store?.openInfo?.mobilePickupMethod?.dineIn
				?.phoneSwitch
		},
	},
	watch: {
		tableNumber: {
			handler(newVal) {
				this.$emit('update:input', { tableNumber: newVal })
			},
		},
		userName: {
			handler(newVal) {
				this.$emit('update:input', { userName: newVal })
			},
		},
		phone: {
			handler(newVal) {
				this.$emit('update:input', { phone: newVal })
			},
		},
		pickUpDraft: {
			// 監聽父層傳入的值，渲染需保留的欄位
			immediate: true,
			deep: true,
			handler(val) {
				if (!val) return
				this.userName = val.userName ?? ''
				this.phone = val.phone ?? ''
			},
		},
	},
	mounted() {
		// 每次結帳後，新的取餐方式都需記憶使用者資訊
		this.userName = this.$store.state.user.userName
		this.phone = this.$store.state.user.userPhone
		this.tableNumber = this.$store.state.user.tableNumber
	},
}
</script>

<style lang="sass" scoped>
.form-row
  display: flex
  flex-wrap: wrap
  .input-wrapper
    width: 48%
    @media screen and (max-width: 420px)
      width: 100%
    &:only-child
      width: 100%
  .input-wrapper:nth-child(3)
    width: 100%
</style>
